export const IMAGE = 'IMAGE';
export const IMAGE_SUCCESS = 'IMAGE_SUCCESS';
export const IMAGE_ERROR = 'IMAGE_ERROR';

export const CLEAR_IMAGES = 'CLEAR_IMAGES';